<script>
import { useMediaQuery } from '@vueuse/core';
import Modal from '../../Modal.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    Modal,
    NextButton,
  },
  props: {
    title: {
      type: String,
      default: 'This is a title',
    },
    description: {
      type: String,
      default: 'This is your description',
    },
    confirmLabel: {
      type: String,
      default: 'Yes',
    },
    cancelLabel: {
      type: String,
      default: 'No',
    },
    mobileEmphasis: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      isMobileViewport: useMediaQuery('(max-width: 767px)'),
    };
  },
  data: () => ({
    show: false,
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    showConfirmation() {
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    confirm() {
      this.resolvePromise(true);
      this.show = false;
    },

    cancel() {
      this.resolvePromise(false);
      this.show = false;
    },
  },
};
</script>

<template>
  <Modal
    v-model:show="show"
    :on-close="cancel"
    :show-close-button="!mobileEmphasis || !isMobileViewport"
    :class="{
      'max-md:!items-center max-md:!bg-black/60 max-md:!p-3': mobileEmphasis,
    }"
    :container-class="
      mobileEmphasis
        ? 'max-md:!w-full max-md:!max-w-md max-md:!rounded-2xl'
        : ''
    "
  >
    <div class="h-auto overflow-auto flex flex-col">
      <div
        v-if="mobileEmphasis"
        class="mx-5 mt-6 hidden size-12 items-center justify-center rounded-full bg-n-ruby-3 text-n-ruby-11 max-md:flex"
        aria-hidden="true"
      >
        <i class="i-lucide-triangle-alert size-6" />
      </div>
      <woot-modal-header
        :header-title="title"
        :header-content="description"
        :class="{
          'max-md:!px-5 max-md:!pt-4 max-md:[&>h2]:!text-lg max-md:[&>h2]:!leading-7':
            mobileEmphasis,
        }"
      />
      <slot name="body" />
      <div
        class="flex flex-row justify-end gap-2 py-4 px-6 w-full"
        :class="{
          'max-md:!grid max-md:grid-cols-2 max-md:px-5 max-md:pb-5 max-md:pt-6':
            mobileEmphasis,
        }"
      >
        <NextButton
          faded
          type="reset"
          :label="cancelLabel"
          :class="{ 'max-md:!h-12 max-md:!w-full': mobileEmphasis }"
          @click="cancel"
        />
        <NextButton
          type="submit"
          :label="confirmLabel"
          :class="{
            'max-md:!h-12 max-md:!w-full max-md:!bg-n-ruby-9 max-md:hover:enabled:!bg-n-ruby-10 max-md:focus-visible:!bg-n-ruby-10':
              mobileEmphasis,
          }"
          @click="confirm"
        />
      </div>
    </div>
  </Modal>
</template>
